<template lang="pug">
  .row(v-if="registration.registration_sections.length > 0")
    .columns.large-24
      article.content-block
        header
          .title(:class="{'title-with-button': editing_as_an_org}")
            | {{t('app.registration.sections')}}
            button.button.right(type="submit" v-if="report_id")
              | {{ t('app.programs.save_and_continue') }}
            .right.change-registration-section-addon(
              v-if="disable_block_for_family",
              v-html="t('app.registration.show.change_section', {org: org_link} )",
            )
        section.content(style="padding-top: 0px;")
          ul.inner-list.sections
            li(v-if="program.sections_instructions", v-linkified="" v-html="to_br(program.sections_instructions)")
            li.checkbox-field2(
              v-for="(rs, idx) in r_sections",
              :key="`section-${idx}`",
              :class="{disabled: isDisabled(rs)}"
            )
              validation-provider(slim :name="'section-input-'+ idx" v-slot="{ errors }")
                label(:for="'section-input-'+ idx" style="margin-bottom:0;" :class="{error: errors[0]}")
                    .content
                      .row
                        KeepHidden(:obj='rs.section', klass='section')
                        ValidTodayDates(:obj='rs.section', klass='section')

                        .columns.large-9
                          // Main section checkbox logic
                          div(v-if="should_render_section_form({registration: registration, program: program})")
                            template(v-if="program.multiple_sections || program.sections.length === 1")
                                input(:id="'section-input-'+ idx" type="checkbox" :checked="!rs._destroy" @change="rs._destroy=!rs._destroy, reset()" v-bind="html_data(rs)")
                                span.label-text
                            template(v-else)
                                input(:id="'section-input-'+ idx" type="radio" name="sections" :checked="!rs._destroy"  v-bind="html_data(rs)" @change="changeRadio(rs)")
                                span.label-text
                          SectionName(:rs="rs") // section name and tooltip
                        // end of .columns.large-9   Main section checkbox logic

                        section_additional_data(:section="rs.section") // additional data like section_times, spaces and section fee.
                    meeting_times(:section="rs.section")
                    limitations(:section="rs.section") // age and grade limitation texts
              // end of label for section
              section_description(:section="rs.section")

              div(v-if="rs.checked() && should_render_section_form({registration: registration, program: program})")
                Options(:rs="rs",:section="rs.section", :disable_block_for_family="disable_block_for_family")
</template>

<script>
  import edit_helper from './edit_helper'
  import WithRequired from './shared/_with_required'
  import KeepHidden from './_keep_hidden'
  import ValidTodayDates from './_valid_today_dates'
  import SectionName from './section/_section_name'
  import section_additional_data from './section/_section_additional_data'
  import meeting_times from './section/_meeting_times'
  import limitations from './section/_limitations'
  import section_description from './section/_section_description'
  import Options from './section/_options'

  export default {
    name: "Sections",
    components: {
      WithRequired, KeepHidden,ValidTodayDates,
      SectionName, section_additional_data,meeting_times,
      limitations,section_description,Options,
    },
    mixins: [edit_helper],
    props: {
      form: Object
    },
    computed: {
      validate() {
        return this.registration.isStillPending()
      },
      r_sections() {
        return this.registration.registration_sections
      },
      org_link(){
        return `<a href="/organizations/${this.program.organization.slug}">${this.program.organization.name}</a>`
      },
      disable_block_for_family(){
        return this.registration.disable_reg_block(this.current_organization, true)
      },
      report_id(){
        return this.$route.query.report_id;
      }
    },
    watch: {
      r_sections(){ this.setDestroy() }
    },
    created() { this.setDestroy() },
    methods: {
      reset(){
        this.form && this.form.reset()
      },
      changeRadio(rs){
        for (const _rs of this.r_sections) {
          _rs._destroy = _rs.section_id !== rs.section_id
        }
        this.reset()
      },
      setDestroy(){
        for (const rs of this.r_sections) {
          rs._destroy = !this.isChecked(rs)

          for (const rso of this.registration.lookupRSOs(rs.section_id)){
            if (rs._destroy) this.$set(rso, "_destroy", rs._destroy)
          }
        }
      },
      isDisabled(rs) {
        if (rs.disabled !== undefined) return rs.disabled

        let val = this.disable_block_for_family;
        if (!val){
          val = this.disable_object_if_no_spaces({object: rs.section, registration: this.registration})
        }
        return rs.disabled =val
      },
      isReadOnly(rs) {
        if (rs.readonly !== undefined) return rs.readonly

        let val = this.isDisabled(rs);
        // allowing family to uncheck field if we are allowed to edit sections based on allow_edit_sections.
        if (rs.checked() && this.registration.allow_edit_sections()) val = false
        return rs.readonly = val
      },
      isChecked(rs) {
        const section = rs.section;

        let checked = rs.checked()
        // unchecking if we are family and reg is not yet completed but section got filled meanwhile
        if (!this.current_organization.id && section.no_spaces() && this.registration.isStillPending()) checked=false;

        return checked
      },
      html_data(rs){
        const section = rs.section;
        return {
          'data-section-automatically-applied': this.section_option_has_auto_applied(rs),
          'data-reg-price-section-type': this.program.display_fee_type,
          disabled: this.isReadOnly(rs),
          class: "no-custom",
        }
      },
      section_option_has_auto_applied(rs){
        for (const rso of this.registration.registration_section_options){
            if (rso.section_option.section_id === rs.section_id && rso.section_option.automatically_applied){
              return true
            }
        }
        return false;
      },
    }
  }
</script>

<style scoped lang="scss">
  .color-gray {
    color: #808080;
  }

  .mb-0 {
    margin-bottom: 0;
  }

  .ml-26 {
    margin-left: 26px;
  }
</style>
